"use client";

import { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { ProviderProps } from "@/types/util";

import { LookupProvider } from "@/context/lookup";
import { RecaptchaProvider } from "@/context/util/recaptcha";
import { useUi } from "@/context/util/ui";

export function LookupProviders(props: ProviderProps) {
  const { metadata, setMetadata } = useUi();

  useEffect(() => {
    if (
      props.metadata.needsAuth !== metadata.needsAuth ||
      props.metadata.title !== metadata.title ||
      props.metadata.url !== metadata.url
    )
      setMetadata(props.metadata);
  }, [props.metadata, metadata, setMetadata]);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_V3_SITE_KEY!}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
    >
      <RecaptchaProvider>
        <LookupProvider>{props.children}</LookupProvider>
      </RecaptchaProvider>
    </GoogleReCaptchaProvider>
  );
}
